import { useTranslation } from 'next-i18next';
import { FC, memo } from 'react';

import AlertCard from '@/components/app/alertCard/AlertCard';
import { AlertCardStatus } from '@/components/app/alertCard/AlertCard.utils';

import {
  Fieldset,
  FieldsetLegend
} from '../createQualification/CreateQualification.styles';
import CustomerForm, { CustomerFormProps } from '../customerForm/CustomerForm';
import { useIsFrenchAndAdminRole } from '@/hooks/auth/useIsFrenchAndAdminRole';

const CreateCustomerForm: FC<CustomerFormProps> = props => {
  const { t } = useTranslation();
  const isFrenchAndAdminRole = useIsFrenchAndAdminRole();

  return (
    <Fieldset data-test="customerform-layout">
      <FieldsetLegend>{t('customerInformation')}</FieldsetLegend>
      {isFrenchAndAdminRole && (
        <AlertCard
          status={AlertCardStatus.INFO}
          text={t('customerFormCompanyInfo')}
        />
      )}
      <CustomerForm {...props} />
    </Fieldset>
  );
};

export default memo(CreateCustomerForm);
